import React, {useEffect, useState} from "react";
import {Box, Drawer} from "@material-ui/core";
import AttributesExpansion from "./AttributesExpansion";
import AttrubuteInfo, {Close} from "./AttrubuteInfo";
import {Button} from "../Button";
import {PriceExpander} from "../../containers/PriceExpander";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
  getActiveCategory,
  getAttributesByCategory,
  getCurrentProject,
  getExpanded, getSelectedAttributesMapped,
} from "../../reducers/project/selectors";
import {Category, IProject} from "../../reducers/project";
import {ProjectActions} from "../../reducers/project/actionsNames";
import addProjectToCart from "../../actions/project/addProjectToCart";
import AlertDialog from "../../containers/Dialog/Dialog";
import {useFetch} from "../../hooks/useFetch";
import content from "../../content";
import {BsTrashFill} from "react-icons/bs";
import CustomExpanders from "./CustomExpanders";

function AttributesDrawer({ open, onClose }: IAttributesDrawer) {
  const [openDrawer, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [attribute, setAttribute] = useState(null);
  const [hide, setHide] = useState(false);
  const dispatch = useDispatch();
  const activeCategory = useSelector(getActiveCategory);
  const selected = useSelector(getSelectedAttributesMapped)

  useEffect(()=> {
    const resize = () => {
      setHide(window.screen.availHeight < 700)
    }

    window.addEventListener('resize', resize)

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  const expanded = useSelector(getExpanded)
  const setExpanded = (expanded) => {
    dispatch({type: ProjectActions.SetExpanded, expanded})
  }

  const project = useSelector(getCurrentProject);
  const attr = useSelector(getAttributesByCategory(activeCategory));
  const reset = () => dispatch({ type: ProjectActions.Reset });
  const [responseNew, requestNew] = useFetch<IProject>("/project/");
  const [responseUpdate, requestUpdate] = useFetch<IProject>(
    "/project/",
    {} as any,
    {
      method: "PUT",
    }
  );

  useEffect(() => {
    setExpanded(activeCategory[0]);
  }, [activeCategory]);

  const tul = selected.filter(Boolean).some(s => s.name.toLowerCase().includes('tuleje metalowe'))

  useEffect(() => {
    if (project.components.length !== 0 && project.components.every(Boolean)) {
      if (project.id) {
        requestUpdate(project, project.id).then((data) => {
          dispatch({
            type: ProjectActions.UpdateHistory,
            project: data,
          });
        });
      } else {
        requestNew(project).then((data) => {
          dispatch({
            type: ProjectActions.UpdateHistory,
            project: data,
          });
        });
      }
    }
  }, [project.components, project.fliped]);

  const toggleExpand = (name: string) => {
    setExpanded(name);
  };

  const toggleNext = () => {
    setExpanded(
        filterActive(activeCategory)[filterActive(activeCategory).indexOf(expanded as any) + 1] || expanded
    );
  };


  const filterActive = (activeCat) => activeCat.filter(a => (a === Category.AddsColor && !!tul) || a !== Category.AddsColor).filter(active => (attr as any).find(at => at.category === active && !at.disabled && at.category !== Category.Jamb))

  const addProject = () => {
    dispatch(addProjectToCart(project));
  };

  const next = () => {
    dispatch({type: ProjectActions.NextMenu})
  }
  const openResetDialog = () => setOpenDialog(true);
  const closeDialog = () => setOpenDialog(false);

  return (
    <Box
      width="40%"
      height="calc(100vh - 103px)"
      style={{ position: "absolute", right: 0, overflow: "hidden" }}
      id="drawer-container"
      position="relative"
      bgcolor="white"
      component="div"
    >
      <AlertDialog
        handleClose={closeDialog}
        title={content.getValue("notification_header_reset")}
        action={reset}
        label={content.getValue("notification_info_reset")}
        open={openDialog}
      />
      <Drawer
        variant={"persistent"}
        anchor={"right"}
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            position: "absolute",
            width: "100%",
            padding: "10px",
            boxSizing: "border-box",
            backgroundColor: "white",
          },
        }}
        BackdropProps={{ style: { position: "absolute" } }}
        ModalProps={{
          container: document.getElementById("drawer-container"),
          style: { position: "absolute" },
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflowX: "hidden",
          }}
        >
          {activeCategory.includes(Category.Custom) && <CustomExpanders expanded={expanded} toggleExpand={toggleExpand}/>}

          {filterActive(activeCategory).map((active, i) => (
            <AttributesExpansion
              key={'attrExp' + i}
              toggleNext={toggleNext}
              expanded={expanded === active}
              toggleExpand={toggleExpand}
              multi={filterActive(activeCategory).length > 1}
              attr={attr.filter((a) => a.category === active)}
              name={mapCategoryToAttribute(active)}
              expandedName={active}
              setOpenInfo={(a: any) => {
                setAttribute(a);
                setOpen(true);
              }}
            />
          ))}
          <div style={{ marginTop: "auto", width: "100%" }}>
            {selected.length !==0 && <PriceExpander />}
            <div style={{ display: "flex", width: "100%" }}>
              <Button
                onClick={openResetDialog}
                disabled={!project.id}
                style={{
                  marginRight: '15px',
                  borderRadius: 0, height: "45px", width: "100%"
                }}
                Icon={
                  <BsTrashFill
                    size={"18px"}
                    color={!project.id?  "rgba(0, 0, 0, 0.26)" : "#C41230"}
                    style={{
                      position: "absolute",
                      right: "20px",
                    }}
                  />
                }
                label={content.getValue("delete_doors")}
                variant={"outlined"}
                color={"secondary"}
              />
              <Button
                  color={"secondary"}
                  variant={"outlined"}
                  disabled={!(!activeCategory.includes(Category.Adds) && !hide) || selected.length  === 0}
                  label={content.getValue('next')}
                  onClick={next}
                  Icon={
                    <svg
                        style={{
                          position: "absolute",
                          right: "20px",
                        }}
                        width="17"
                        height="8"
                        viewBox="0 0 17 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                          fill={(!(!activeCategory.includes(Category.Adds) && !hide) || selected.length  === 0) ? "rgba(0, 0, 0, 0.26)" : "#C41230"}
                      />
                    </svg>
                  }
                  style={{
                    marginRight: '15px',
                    borderRadius: 0, height: "45px", width: "100%"
                  }}
              />
              <Link
                style={{
                  width: "100%",
                  pointerEvents: !project.id ? "none" : "all",
                }}
                to={"/cart"}
              >
                <Button
                  color={"secondary"}
                  onClick={addProject}
                  variant={"outlined"}
                  disabled={!project.id}
                  Icon={
                    <svg                         style={{
                      position: "absolute",
                      right: "20px",
                    }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={!project.id ? "rgba(0, 0, 0, 0.26)" : "#C41230"} width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg>
                  }
                  label={content.getValue("button_go_to_cart")}
                />
              </Link>
            </div>
          </div>
        </div>
      </Drawer>
      <AttrubuteInfo
        attribute={attribute}
        open={openDrawer}
        onClose={() => setOpen(false)}
      />
    </Box>
  );
}

export function mapCategoryToAttribute(category: Category) {
  switch (category) {
    case Category.Model:
      return content.getValue("attributes_models");
    case Category.Adds:
      return content.getValue("attributes_adds");
    case Category.Color:
      return content.getValue("attributes_colors");
    case Category.Variant:
      return content.getValue("attributes_variants");
    case Category.Handle:
      return content.getValue("attributes_handles");
    case Category.JambColor:
      return content.getValue("attributes_jambs_colors");
    case Category.JambSize:
      return content.getValue("attributes_jambs_sizes");
    case Category.Jamb:
      return content.getValue("attributes_jambs");
    case Category.Size:
      return content.getValue("attributes_size");
    case Category.Signboard:
      return content.getValue("attributes_signboard");
    case Category.Glass:
      return content.getValue("attributes_glass");
    case Category.Side:
      return content.getValue("attributes_side");
    case Category.AddsColor:
      return content.getValue("attributes_colors");
    case Category.HandleColor:
      return content.getValue("attributes_colors");
    default:
      return "error";
  }
}

export interface IAttributesDrawer {
  open: boolean;
  onClose: () => void;
}

export default AttributesDrawer;
